require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-izzy-baer.json") })
        }
      }, "path---blog-author-izzy-baer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-izzy-baer!./.cache/json/blog-author-izzy-baer.json
// module id = 645
// module chunks = 231608221292675